<template>
	<el-container direction="vertical">
		<el-main class="table-main table-content" data-cy="elMainTable">
			<form @submit.prevent="onInRowEnter">
				<el-table v-if="table" ref="singleTable" :key="tableKey" v-loading="loadingCmp" :row-class-name="rowClassName" :data="editTableRows" highlight-current-row
					:row-key="rowKeyCmp" :current-row-key="selectRow" border :summary-method="summaryMethod" :show-summary="isSummaryVisible"
					:empty-text="getNoDataText"
					:cell-style="tableCellStyle"
					@selection-change="handleSelectionChange"
					@cell-click="handleCellClick">
					<el-table-column v-if="selection" type="selection" data-cy="selectionColumn" />
					<el-table-column v-for="(item, index) in columnsVisible" :key="item.columnId"
						v-bind="columnProps(item.columnName)" :label="getColumnLabel(item.columnName)">
						<dms-table-header v-if="showSort" slot="header" :label="getColumnLabel(item.columnName)" :current-sort-info.sync="sortInfo" :column="item"
							:sortable="!hasVisibleInnerColumn(item)" @sort-change="handleSortChange" />
						<slot slot-scope="scope" :name="item.columnName" :column-id="item.columnId" :row="scope.row" :row-model="rowModel.cells" :update-col="updateColumn"
							:editable="(!isEditationDisabled && isColumnEditable(item.columnName) || canEditTable)" :is-editing="isEditingRow(scope.$index)">
							<dms-tooltip v-if="(isEditationDisabled || !isColumnEditable(item.columnName))"
								:content="tooltipText(scope.row.cells[item.columnId], scope.$index, scope.row)" popper-class="btn-tooltip" placement="right-end" effect="dark">
								<dms-table-cell v-if="hyperlinkColumn === item.columnName" :value-type="item.valueType"
									:value="scope.row.cells[item.columnId]" class="hyperlink-cell" />
								<dms-table-cell v-else :value-type="item.valueType"
									:value="scope.row.cells[item.columnId]" />
							</dms-tooltip>
							<div v-else>
								<dms-tooltip :content="tooltipText(scope.row.cells[item.columnId], scope.$index, scope.row)" popper-class="btn-tooltip" placement="right-end" effect="dark">
									<dms-table-cell v-if="lazyEditCells && !isEditingRow(scope.$index)" :value-type="item.valueType"
										:value="scope.row.cells[item.columnId]" @dblclick.native="onCellDoubleClick(scope.$index, index)" />
									<dms-editable-table-cell v-else :ref="getCellRef(scope.$index, index)" v-bind="item" :value-type="item.valueType" :item="item"
										:value="scope.row.cells[item.columnId]" :editing-value.sync="rowModel.cells[item.columnId]"
										:is-editing="isEditingRow(scope.$index)" @keydown.native="(event) => onCellKeyDown(event, scope.$index, index)"
										@edit-cell-dblclick="onCellDoubleClick(scope.$index, index)" />
								</dms-tooltip>
							</div>
						</slot>
						<el-table-column v-for="(subItem, idx) in item.columns" :key="subItem.columnId" v-bind="columnProps(subItem.columnName)"
							:label="getColumnLabel(subItem.columnName)">
							<dms-table-header v-if="showSort" slot="header" :label="getColumnLabel(subItem.columnName)" :current-sort-info.sync="sortInfo" :column="subItem"
								:sortable="!hasVisibleInnerColumn(subItem)" @sort-change="handleSortChange" />

							<slot slot-scope="scope" :name="subItem.columnName" :column-id="subItem.columnId" :row="scope.row" :row-model="rowModel.cells" :update-col="updateColumn"
								:editable="(!isEditationDisabled && isColumnEditable(subItem.columnName) || canEditTable)" :is-editing="isEditingRow(scope.$index)">
								<dms-table-cell v-if="isEditationDisabled || !isColumnEditable(subItem.columnName)" :value-type="subItem.valueType"
									:value="scope.row.cells[subItem.columnId]" />
								<dms-table-cell v-else-if="lazyEditCells && !isEditingRow(scope.$index)" :value-type="subItem.valueType"
									:value="scope.row.cells[subItem.columnId]" @dblclick.native="onCellDoubleClick(scope.$index, idx)" />
								<dms-editable-table-cell v-else :ref="getCellRef(scope.$index, idx)" v-bind="subItem" :value-type="subItem.valueType" :item="subItem"
									:value="scope.row.cells[subItem.columnId]" :editing-value.sync="rowModel.cells[subItem.columnId]"
									:is-editing="isEditingRow(scope.$index)" @keydown.native="(event) => onCellKeyDown(event, scope.$index, idx)"
									@edit-cell-dblclick="onCellDoubleClick(scope.$index, idx)" />
							</slot>
						</el-table-column>
					</el-table-column>
					<el-table-column v-if="(!isEditationDisabled || canEditTable)" width="76px" fixed="right" class-name="table-right-buttons">
						<template slot-scope="scope">
							<div v-show="(isEditRowEnabled(scope.$index, scope.row))">
								<el-button icon="el-icon-edit" :data-cy="`btn-edit-polozka-${scope.$index}`"
									@click="editRow(scope.$index, scope.row)" />
								<el-button v-if="enabledDelete && scope.$index > editDeleteStartIndex" :disabled="isDeleteRowDisabled" type="secondary"
									icon="el-icon-delete" :data-cy="`btn-delete-polozka-${scope.$index}`"
									@click="deleteRow(scope.$index, scope.row)" />
							</div>
							<div v-show="isEditingRow(scope.$index)">
								<el-button type="primary" icon="el-icon-check" :data-cy="`btn-save-polozka-${scope.$index}`"
									@click="saveRow(scope.$index)" />
								<el-button type="default" icon="el-icon-close" :data-cy="`btn-cancel-polozka-edit-${scope.$index}`" @click="cancelRowEdit(scope.row)" />
							</div>
						</template>
					</el-table-column>
				</el-table>

				<input v-show="false" type="submit">
			</form>
		</el-main>
		<el-footer v-show="showFooter" height="50px" class="table-footer">
			<dms-col :md="18" :sm="18" :xs="20">
				<dms-paging v-if="isPaginationNecessary" v-show="total" :current-page.sync="currentPage" :total="total" :page-size="rowsOnPage" @current-change="pageChanged" />
			</dms-col>
			<dms-col :md="6" :sm="6" :xs="4" class="div-right-align">
				<dms-table-setting :columns="table.columns" :save-visible="saveSettingVisible" class="float-right" @update:columns="updateColumnsSetting"
					@save-column-setting="saveColumnSetting" />
				<dms-button v-if="showRefresh" icon="el-icon-refresh-right" class="float-right" :disabled="false"
					@click="$emit('refresh', table.name)" />
				<dms-button v-if="showRefresh" label-key="Export" class="float-right" :disabled="false"
					@click="$emit('export', table.name)" />
			</dms-col>
		</el-footer>
	</el-container>
</template>

<script>
import _ from 'lodash';
import DmsTable from '@/main/components/dms/layout/Table.vue';
import { EditableStatus } from '@/main/utils/table';

import DmsEditableTableCell from './EditableTableCell.vue';

const KEY_UP = 'ArrowUp';
const KEY_DOWN = 'ArrowDown';
const KEY_LEFT = 'ArrowLeft';
const KEY_RIGHT = 'ArrowRight';

export default DmsTable.extend({
	name: 'DmsEditableTable',
	components: { DmsEditableTableCell },
	props: {
		tableCellStyle: { type: Function, required: false },
		summaryMethod: { type: Function, required: false },
		enabledDelete: { type: Boolean },
		enabledCreate: { type: Boolean },
		showSort: { type: Boolean, default: true },
		canEditRow: { type: Function, default: () => true },
		// Opt-in perf: skip the last-page jump in createRow when already on the last page.
		// Default false => all existing screens behave exactly as before.
		skipPageJumpOnCreate: { type: Boolean, default: false },
		// Opt-in perf: render non-editing rows with plain read-only cells instead of full editors.
		// Default false => all existing screens behave exactly as before.
		lazyEditCells: { type: Boolean, default: false },
		// Opt-in perf: don't cancel the active row edit / reset to page 1 when loadingCmp toggles
		// from in-row async work (e.g. part lookups). Default false => all existing screens unchanged.
		preserveEditOnLoad: { type: Boolean, default: false },
		beforeRowSave: { type: Function, required: false },
		firstRowCantEditAndDelete: { type: Boolean },
		enableDynamicDefaultRowModel: { type: Boolean, default: false },
		dynamicDefaultRowModel: { cells: {} },
		canEditTable: { type: Boolean, default: false },
	},
	data() {
		return {
			doReloadSelection: false,
			editingRowIndex: null,
			editingRowId: null,
			selected: { row: null, cell: null },
			rowModel: { cells: {} },
			insertIdSequenc: -1,
			isShowTooltip: false,
			tableKey: 0,
		};
	},
	computed: {
		isPaginationNecessary() {
			return this.total > this.rowsOnPage;
		},
		editDeleteStartIndex() {
			return this.firstRowCantEditAndDelete ? 0 : -1;
		},
		selection() {
			return (
				!!this.multipleSelection
				|| this.table.columns.some(
					(item) => item.columnName === 'CHECKBOX',
				)
			);
		},
		notDeletedRows() {
			return !_.isNil(this.updateStatusIndex)
				? this.table.rows.filter(
					({ cells }) => cells[this.updateStatusIndex] !== EditableStatus.DELETED,
				)
				: this.table.rows;
		},
		filteredRows() {
			return !this.query
				? this.notDeletedRows
				: this.notDeletedRows.filter((item) => Object.values(item.cells).find((a) => this.findQuery(a)));
		},
		updateStatusIndex() {
			return this.table.cellNames && this.table.cellNames.UpdateStatus;
		},
		editTableRows() {
			return this.isCreatingRow
				? [...this.rowsOnCurrentPage, this.rowModel]
				: this.rowsOnCurrentPage;
		},
		editTableRowsAll() {
			return this.isCreatingRow
				? [...this.rowsCmp, this.rowModel]
				: this.rowsCmp;
		},
		isCreatingRow() {
			return this.rowsCmp && this.editingRowIndex === this.rowsCmp.length;
		},
		rowsCmp: {
			get() {
				return this.table ? this.table.rows : this.rows;
			},
			set(rows) {
				this.$emit('update-rows', { tableName: this.table.name, rows });
			},
		},

		/**
		 * true if any required field is empty
		 */
		isSaveRowDisabled() {
			const reducer = (result, options) => {
				const { required } = this.columnSettings(options.columnName) || false;
				return result || (required && (this.rowModel.cells[options.columnId] === null || _.trim(this.rowModel.cells[options.columnId]) === ''));
			};
			return _.reduce(this.table.columns, reducer, false);
		},
		isCreateRowDisabled() {
			return !this.enabledCreate || this.isEditationDisabled;
		},
		isDeleteRowDisabled() {
			return !this.enabledDelete || this.isEditationDisabled;
		},
		showCreateRowButton() {
			return this.enabledCreate && this.showCreateRowButton && !this.isEditationDisabled;
		},
		isEditationDisabled() {
			return this.isViewMode || this.tableDisabled;
		},
		isSummaryVisible() {
			return this.summaryMethod !== null && this.summaryMethod !== undefined;
		},
		defaultRowModelCmp() {
			if (this.table.columns.length > 0 && !this.table.defaultRowModel && !this.enableDynamicDefaultRowModel) {
				this.table.prepareDefaultRowModel();
			}
			if (this.enableDynamicDefaultRowModel) {
				this.table.defaultRowModel = this.dynamicDefaultRowModel;
			}
			return this.table.defaultRowModel || { cells: {} };
		},
		// Computed once per render instead of recomputed on every isEditingRow() call per cell.
		editingIndexForPage() {
			// Preserve null when nothing is being edited — null - number coerces to 0 and falsely matches row 0.
			if (this.editingRowIndex === null) return null;
			return this.editingRowIndex - (this.currentPage - 1) * this.rowsOnPage;
		},
	},
	watch: {
		loadingCmp() {
			// Order screen: in-row async work toggles loading too — don't cancel the edit being worked on.
			if (this.preserveEditOnLoad) {
				return;
			}
			this.cancelRowEdit();
			this.currentPage = 1;
		},
		currentPage() {
			this.doReloadSelection = true;
		},
	},

	methods: {
		handleCellClick(row, column, cell) {
			if (cell) {
				const isHyperLinkColumn = cell.querySelector('.hyperlink-cell');
				if (this.hasHyperLinkClickListener && isHyperLinkColumn && this.hyperlinkColumn in this.table.cellNames) {
					this.$emit('hyperLinkClick', { row });
				}
			}
		},
		updateColumnsSetting({
			visibles,
			columns,
		}) {
			const hasntCol = (col) => !columns.some((vcol) => vcol.columnId === col.columnId);
			const filtered = this.table.columns.filter(hasntCol);

			this.table.columns = visibles
				? [...columns, ...filtered]
				: [...filtered, ...columns];
			this.tableKey += 1; // rerender table component
		},
		rowToEditedRow(row, updateStatus) {
			return {
				tableName: this.table.name,
				updateStatus,
				rowId: row ? row.cells[this.table.cellNames.idColumn] : undefined,
				row,
			};
		},
		rowToRejectRow(row, updateStatus) {
			return {
				tableName: this.table.name,
				updateStatus,
				rowId: row ? row.cells[this.table.cellNames.idColumn] : undefined,
				row,
			};
		},
		columnSettings(columnName) {
			return this.table.columnSettings
				? this.table.columnSettings[columnName]
				: null;
		},
		createRow() {
			if (this.isCreateRowDisabled) return;
			if (this.total > 0) {
				const pageCount = Math.ceil(this.total / this.rowsOnPage);
				if (!this.skipPageJumpOnCreate || this.currentPage !== pageCount) {
					this.currentPage = pageCount;
				}
			}
			this.cancelRowEdit();
			this.editingRowIndex = this.sortedRows.length;
			this.rowModel = { cells: { ...this.defaultRowModelCmp.cells } };
			this.rowModel.cells[this.rowKey] = this.insertIdSequenc;
			this.insertIdSequenc -= 1;
			!_.isNil(this.updateStatusIndex)
			&& (this.rowModel.cells[this.updateStatusIndex] = EditableStatus.INSERTED);
		},
		deleteRow(rowIndex, row) {
			if (this.isDeleteRowDisabled) return;
			const updateRow = !_.isNil(this.updateStatusIndex)
				&& row.cells[this.updateStatusIndex] !== EditableStatus.INSERTED
				? {
					cells: {
						...row.cells,
						[this.updateStatusIndex]: EditableStatus.DELETED,
					},
					operations: row.operations,
				}
				: undefined;
			this.$emit('update:row', {
				...this.rowToEditedRow(updateRow, EditableStatus.DELETED),
				rowId: row.cells[this.table.cellNames.idColumn],
				rowIndex,
			});
			this.$emit('delete:row', {
				rowId: row.cells[this.table.cellNames.idColumn],
			},
			row);
		},
		editRow(rowIndex, row) {
			const startIndex = (this.currentPage - 1) * this.rowsOnPage;
			if (
				!_.isNil(this.updateStatusIndex)
				&& row.cells[this.updateStatusIndex] !== EditableStatus.INSERTED
			) {
				row.cells[this.updateStatusIndex] = EditableStatus.MODIFIED;
			}

			this.editingRowIndex = (rowIndex + startIndex);
			this.editingRowId = this.getRowKey(row);
			this.rowModel = { cells: { ...row.cells } };
			this.$emit('update:editrow', {
				row,
				rowIndex,
			});
		},
		async saveRow(rowIndex) {
			const rows = this.editTableRowsAll;
			let editedRow;
			if (this.editingRowId) {
				editedRow = rows.find(
					(row) => this.getRowKey(row) === this.editingRowId,
				);
				editedRow.cells = this.rowModel.cells;
			} else {
				rows[this.editingRowIndex].cells = this.rowModel.cells;
				editedRow = rows[this.editingRowIndex];
			}

			if (this.beforeRowSave && await this.beforeRowSave({ row: editedRow }) === false) {
				return;
			}
			this.$emit('row-saved', { row: editedRow });

			this.rowsCmp = rows;
			this.cancelRowEdit();
		},

		cancelRowEdit(row) {
			this.$emit('row-cancel', { row });
			this.rowModel = { cells: { ...this.defaultRowModelCmp.cells } };
			this.editingRowIndex = null;
			this.editingRowId = null;
		},
		isEditingRow(rowIndex) {
			if (!this.lazyEditCells) {
				// Default path: unchanged for every screen not opting into lazyEditCells.
				const startIndex = (this.currentPage - 1) * this.rowsOnPage;
				return (rowIndex + startIndex) === this.editingRowIndex;
			}
			return rowIndex === this.editingIndexForPage;
		},
		tooltipText(value) {
			return `${value}`;
		},
		columnProps(columnName) {
			const colSetting = this.columnSettings(columnName);
			return _.pickBy(colSetting, (value, key) => key !== 'required');
		},
		getColumnLabel(columnName) {
			const colSetting = this.columnSettings(columnName);
			const required = _.isNil(colSetting) ? false : colSetting.required;
			return `${required ? '* ' : ''}${this.getLocalization(columnName)}`;
		},
		onInRowEnter() {
			this.saveRow(this.editingRowIndex);

			/**
			 * if editingrow - save editing row and se it as selected
			 * else (if selected row) start editing selected row - on cell 1
			 * else do nothing
			 */
		},
		onCellDoubleClick(rowIndex, columnId) {
			if (rowIndex > this.editDeleteStartIndex) {
				this.editRow(rowIndex, this.editTableRows[rowIndex]);
				this.setCurrentRow(this.editTableRows[rowIndex]);
				this.editCell(rowIndex, columnId);
			}
		},
		isColumnEditable(columnName) {
			if (_.isEmpty(this.table.columnSettings)) return this.table.isEditable;

			const colSetting = this.table.columnSettings[columnName];
			return _.isNil(colSetting) ? false : colSetting.isEditable;
		},
		onCellKeyDown(event, rowIndex, cellIndex) {
			if (this.editingRowIndex === null) {
				return;
			}
			let newRowIndex = rowIndex;
			let newCellIndex = cellIndex;
			switch (event.code) {
				case KEY_UP: {
					newRowIndex = rowIndex - 1;
					if (!this.isSaveRowDisabled) {
						this.saveRow(rowIndex);
					}
					break;
				}
				case KEY_RIGHT: {
					if (
						cellIndex + 1 < this.columnsVisible.length
						&& this.isColumnEditable(this.columnsVisible[cellIndex + 1].columnName)
					) {
						newCellIndex = cellIndex + 1;
					}
					break;
				}
				case KEY_DOWN: {
					newRowIndex = rowIndex + 1;
					if (!this.isSaveRowDisabled) {
						const isLastRow = !this.editingRowId || newRowIndex === this.editTableRows.length;
						this.saveRow(rowIndex);
						if (isLastRow) {
							this.$nextTick(() => {
								this.createRow();
							});
						}
					}
					break;
				}
				case KEY_LEFT: {
					if (
						cellIndex > 0
						&& this.isColumnEditable(this.columnsVisible[cellIndex - 1].columnName)
					) {
						newCellIndex = cellIndex - 1;
					}
					break;
				}
				default: {
					return;
				}
			}

			this.$nextTick(() => {
				newRowIndex = Math.min(newRowIndex, this.editTableRows.length - 1);
				newRowIndex = Math.min(newRowIndex, this.rowsOnPage - 1);
				newRowIndex = Math.max(newRowIndex, 0);
				newCellIndex = Math.min(newCellIndex, this.columnsVisible.length - 1);
				newCellIndex = Math.max(newCellIndex, 0);

				if (rowIndex !== newRowIndex || cellIndex !== newCellIndex) {
					if (rowIndex !== newRowIndex) {
						this.editRow(newRowIndex, this.editTableRows[newRowIndex]);
						this.setCurrentRow(this.editTableRows[newRowIndex]);
					}
					event.preventDefault();
					this.editCell(newRowIndex, newCellIndex);
				}
			});
		},
		getCellRef(rowIndex, columnIndex) {
			return `cell_${rowIndex}_${columnIndex}`;
		},
		editCell(rowIndex, columnIndex) {
			const cellRef = this.getCellRef(rowIndex, columnIndex);
			this.$nextTick(() => {
				const inputRefs = this.$refs[cellRef][0].$children[0].$refs;
				const input = inputRefs.input || inputRefs.numeric;
				input && input.focus();
			});
		},
		setCurrentRow(row) {
			this.$refs.singleTable.setCurrentRow(row);
		},
		handleSortChange({ columnId, order }) {
			this.cancelRowEdit();
			this.sortInfo.columnId = columnId;
			this.sortInfo.order = order;
		},
		pageChanged() {
			this.cancelRowEdit();
			this.reloadSelection();
		},
		handleTableRowsChange() {},
		updateColumn(newValue, columnId) {
			this.rowModel.cells = { ...this.rowModel.cells, [columnId]: newValue };
		},
		isEditRowEnabled(rowIndex, row) {
			return !this.isEditingRow(rowIndex) && this.canEditRow(row);
		},
		handleSelectionChange(val) {
			if (!this.doReloadSelection) {
				_.remove(this.multipleSelection, (i) => this.rowsOnCurrentPage.some((t) => t === i));
				this.$emit('update:multipleSelection', [
					...val,
					...this.multipleSelection,
				]);
			} else {
				this.doReloadSelection = false;
			}
		},
	},
});
</script>

<style lang="scss" scoped>
.table-main {
	padding: 0;
}
.table-input.frm-group {
	margin-bottom: 0;
}
</style>
